import codes from './assets/codes.json'

export const getStatusCodeLabel = (status) => {
  const code = codes[status];
  return code ? `${code.code} - ${code.message}` : status;
}
